import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'tf-text-input',
  standalone: true,
  imports: [FormsModule, InputTextModule],
  template: `
    <input
      pInputText
      [id]="inputId()"
      [placeholder]="placeholder()"
      [ngModel]="value()"
      (ngModelChange)="onValueChange($event)"
      [class.ng-invalid]="invalid()"
      [class.ng-dirty]="invalid()"
      class="w-full"
    />
  `,
  styles: ':host { display: block; width: 100%; }',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextInputComponent {
  readonly value = input<string>('');
  readonly placeholder = input<string>('');
  readonly inputId = input<string>('tf-text-input');
  readonly invalid = input<boolean>(false);
  @Output() readonly valueChange = new EventEmitter<string>();

  onValueChange(val: string): void {
    this.valueChange.emit(val);
  }
}
